import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const AUDIT_LOGS_ENABLED = process.env.REACT_APP_AUDITLOGS === "YES";

const Sidebar = () => {
  const { logout } = useAuth();

  const navItems = [
    { 
      path: "/dashboard", 
      label: "Dashboard", 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="7" height="7"></rect>
          <rect x="14" y="3" width="7" height="7"></rect>
          <rect x="14" y="14" width="7" height="7"></rect>
          <rect x="3" y="14" width="7" height="7"></rect>
        </svg>
      )
    },
    ...(AUDIT_LOGS_ENABLED ? [{
      path: "/audit-logs",
      label: "Audit Logs",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
      )
    }] : []),
    {
      path: "/contact-queries",
      label: "Contact Queries",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </svg>
      )
    },
  ];

  return (
    <div className="w-64 bg-[#f8f9fa] border-r border-gray-200 h-screen flex flex-col">
      {/* Header */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center gap-3">
          {/* <div className="w-10 h-10 bg-[#1E293B] rounded-lg flex items-center justify-center text-white font-bold text-lg"> */}
            <span className="w-[30px] h-[30px] rounded-lg bg-gradient-to-br from-navy to-indigo grid place-items-center text-white text-[13px] font-extrabold shadow-[inset_0_0_0_1px_rgba(255,255,255,0.15)]">Q</span>
          {/* </div> */}
          <span className="text-[#1f2937] font-semibold text-lg">QB OAuth</span>
        </div>
      </div>

      {/* Workspace Label */}
      <div className="px-4 pt-6 pb-2">
        <span className="text-xs font-semibold text-[#6b7280] uppercase tracking-wider">Workspace</span>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-2">
        <ul className="space-y-1">
          {navItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all text-[15px] ${
                    isActive
                      ? "bg-[#e5e7eb] text-[#1f2937] font-medium"
                      : "text-[#4b5563] hover:bg-[#e5e7eb] hover:text-[#1f2937]"
                  }`
                }
              >
                <span className="flex-shrink-0">{item.icon}</span>
                <span>{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Logout Button */}
      <div className="p-4 border-t border-gray-200">
        <button
          onClick={logout}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-[15px] text-[#4b5563] hover:bg-[#e5e7eb] hover:text-[#1f2937] transition-all"
        >
          <span className="rotate-180">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
          </span>
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
